import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import FilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { format, isValid, parse } from "date-fns";

const BagBookingFilterModal = ({
  show,
  handleClose,
  setCustomerData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  defaultFilterData,
  handleItemsIncludedClick,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: filterData,
    mode: "onChange",
  });

  // Watch all form values to check if a filter has a value
  const watchedValues = watch();

  // Function to check if a tab has an active filter value
  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Bag No":
        return filterData?.bagNo && filterData.bagNo.trim() !== "";
      case "Created Date":
        return (
          (filterData?.fromDate && filterData.fromDate !== "") ||
          (filterData?.toDate && filterData.toDate !== "")
        );
      default:
        return false;
    }
  };

  const loggedInUserName = sessionStorage.getItem("username");

  const [selectedTab, setSelectedTab] = useState("Bag No");
  const [loading, setLoading] = useState(false);

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    fetchBagData(1);
  };

  const fetchBagData = async (pageNo = 1) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        bagNo: filterData.bagNo || "",
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_BAG_MASTER}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(
          response?.data?.data,
          handleItemsIncludedClick,
        );
        setCustomerData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });

        setCustomerData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response, handleItemsIncludedClick) => {
    return response?.map((user, index) => {
      let formattedCreDate = null;
      let formattedStrDate = null;

      if (user?.createdDate) {
        const parsed = parse(
          user.createdDate,
          "dd-MM-yyyy HH:mm:ss",
          new Date(),
        );
        if (isValid(parsed)) {
          formattedCreDate = parsed;
        } else {
          console.warn("Invalid createdDate:", user.createdDate);
        }
      }

      if (user?.startDateTime) {
        const parsed = parse(
          user.startDateTime,
          "dd-MM-yyyy HH:mm:ss",
          new Date(),
        );
        if (isValid(parsed)) {
          formattedStrDate = parsed;
        } else {
          console.warn("Invalid startDateTime:", user.startDateTime);
        }
      }

      const itemCount = user.itemsIncluded?.length || 0;

      const itemsIncludedIds = Array.isArray(user.itemsIncluded)
        ? user.itemsIncluded
        : []; // backend expects array

      return {
        ...user,

        itemsIncludedIds,

        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",

        startDateTime: formattedStrDate
          ? [
              format(formattedStrDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedStrDate, "HH:mm:ss"),
            ]
          : "",

        itemsIncluded: (
          <span
            className="text-blue-600 underline cursor-pointer"
            onClick={() => handleItemsIncludedClick(user)}
          >
            {itemCount > 0
              ? `${itemCount} Item${itemCount > 1 ? "s" : ""}`
              : "No Items"}
          </span>
        ),
      };
    });
  };

  const onReset = () => {
    reset({
      bagNo: "",
      fromDate: "",
      toDate: "",
    });
    setFilterData({
      bagNo: "",
      fromDate: "",
      toDate: "",
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title font-medium">
                    Filters
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form">
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Bag No", "Created Date"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {selectedTab === "Bag No" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Bag No</label>
                            <input
                              type="text"
                              placeholder="Enter Bag No"
                              className="dateInput"
                              value={filterData.bagNo}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  "",
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  bagNo: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      onClick={handleSubmit(onSubmit)}
                      className="btn btn-submit !rounded-lg w-[133px]"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back !rounded-lg w-[133px]"
                      onClick={onReset}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BagBookingFilterModal;
